import { render, staticRenderFns } from "./inputPotonganTambahan.vue?vue&type=template&id=190e977e&"
import script from "./inputPotonganTambahan.vue?vue&type=script&lang=js&"
export * from "./inputPotonganTambahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports